import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"


import { LineCharComponent } from "@/components/Diff/DiffLineChar.tsx"
import { Horizontal } from "@/components/Flex.ts"
import { ExpandRegular, Icon16 } from "@/icons/Icons.ts"
import { preventTextSelection } from "@/lib/std.ts"

import type { IntRange } from "@/lib/diff/misc.ts"
import type { Property } from "csstype"
import type { IObservableValue } from "mobx"


export const HunkContentComponent = observer((props: {
  range: IntRange
  gutterWidth: IObservableValue<Property.Width>

  expand: (side: "top" | "bottom" | "both") => void
}) => {
  const size = props.range.size
  const gutterWidth = props.gutterWidth.get()

  return (
    <Container gutterWidth={gutterWidth} onClick={() => props.expand("both")} onMouseDown={preventTextSelection}>
      <ExpandBoth gutterWidth={props.gutterWidth.get()}>
        <ExpandRegular className={Icon16} />
      </ExpandBoth>

      <LineCharComponent />

      <Content>
        {size === 1 ? "1 line hidden" : `${size} lines hidden`}
      </Content>
    </Container>
  )
})

const Container = styled(Horizontal)<{ gutterWidth: Property.Width }>`
  align-items: center;

  position: sticky;
  left: ${props => props.gutterWidth};

  cursor: pointer;

  z-index: 1;

  &:hover {
    color: var(--main-color);
  }
`

const Content = styled.div`
  font-style: italic;
  font-size: 14px;
  line-height: 20px;
`

const ExpandBoth = styled(Horizontal)<{ gutterWidth: Property.Width }>`
  align-items: center;
  justify-content: center;

  width: 28px;
  height: 28px;
  margin-left: -14px;
`